// extracted by mini-css-extract-plugin
export default {"button":"T2vqzH","disabled":"BwDkyV","container":"N3oBPh","title":"lHj3TA","icon":"MV5Vpd","style-gold-50":"uPB0Xj","style-gold-30":"X8V27B","style-black":"x2Dnd8"};